if (!customElements.get('faq-accordion')) {
  class FaqAccordion extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-single-open')) return;

      this.handleToggle = this.handleToggle.bind(this);

      // 'toggle' does not bubble, so listen during the capture phase instead.
      this.addEventListener('toggle', this.handleToggle, true);

      this.closeExtras();
    }

    disconnectedCallback() {
      if (this.handleToggle) this.removeEventListener('toggle', this.handleToggle, true);
    }

    /**
     * Open questions belonging to this section only.
     * @returns {NodeList}
     */
    get openQuestions() {
      return this.querySelectorAll('details[open]:not(.is-closing)');
    }

    /**
     * Closes every open question except one.
     * @param {Element} keep - Details element to leave open.
     * @param {boolean} animate - Use the theme disclosure transition, or close instantly.
     */
    closeOthers(keep, animate) {
      this.openQuestions.forEach((details) => {
        if (details === keep) return;

        const disclosure = details.closest('details-disclosure');

        if (animate && disclosure && typeof disclosure.close === 'function') {
          disclosure.close();
        } else {
          details.open = false;
        }
      });
    }

    /**
     * Handles more than one block being set to 'Open by default'.
     */
    closeExtras() {
      const [first] = this.openQuestions;
      if (first) this.closeOthers(first, false);
    }

    /**
     * Handles 'toggle' events from any question in this section.
     * @param {object} evt - Event object.
     */
    handleToggle(evt) {
      const details = evt.target;

      // Ignore the closing half of a toggle, and the theme's deferred close.
      if (!details.open || details.classList.contains('is-closing')) return;

      this.closeOthers(details, true);
    }
  }

  customElements.define('faq-accordion', FaqAccordion);
}
